import { useQuery } from '@tanstack/react-query';
import { getSettings } from '../services/CalendarSettingsService';
import { calendarSettingsKeys } from './queryKeys';
export function useCalendarSettings() {
    return useQuery({
        queryKey: calendarSettingsKeys.settings(),
        queryFn: getSettings,
        staleTime: 5 * 60 * 1000,
        retry: 3
    });
}
